#<template>
  <v-card>
    <v-dialog v-model="showDialog" width="400" @click:outside="closed">
      <v-card class="d-flex flex-column pa-6">
        <div class="d-flex justify-space-between">
          <h2 class="mb-3">{{ title }}</h2>
          <v-btn icon text @click="closed">
            <v-icon class="primary--text">
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <div class="my-3">
          <p>Revisionsname: {{ revisionName }}</p>
          <p>Antriebe: {{ amountAct }}</p>
          <p class="" v-html="text"></p>
        </div>
        <div class="d-flex mt-6">
          <v-btn color="error" @click="confirmed">Bestätigen</v-btn>
          <v-btn class="ml-3" @click="closed">Abbrechen</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ConfirmRevisionDialogComponent extends Vue {

  @Prop({ default: false })
  public showDialog!: boolean;

  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: '' })
  public amountAct!: number;

  @Prop({ default: '' })
  public revisionName!: number;

  @Prop({ default: '' })
  public text!: string;

  public confirmed() {
    this.$emit('confirmed');
  }

  public closed() {
    this.$emit('closed');
  }

}

</script>
